export default {
  terms:
    'Når du afgiver din ordre, accepterer du vores <TermsLink>Vilkår og betingelser</TermsLink> og vores <PrivacyPolicyLink>Privatlivspolitik</PrivacyPolicyLink>.',
};
